import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'

import './ExpandableCard.scss'

type ExpandableCardProps = {
  title: React.ReactNode
  subtitle?: React.ReactNode
  children: React.ReactNode
  isExpanded?: boolean
  onChange?: (args: { isExpanded: boolean }) => void
}

export const ExpandableCard: React.FC<ExpandableCardProps> = ({
  title,
  subtitle,
  children,
  isExpanded: isExpandedByDefault = false,
  onChange,
}) => {
  const [isExpanded, setIsExpanded] = useState(isExpandedByDefault)
  const [bodyMaxHeight, setBodyMaxHeight] = useState(0)

  const bodyRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!bodyRef.current) return

    if (isExpanded) {
      setBodyMaxHeight(bodyRef.current?.scrollHeight)
    } else {
      setBodyMaxHeight(0)
    }
  })

  const handleButtonClick = () => {
    const _isExpanded = !isExpanded
    setIsExpanded(_isExpanded)
    onChange && onChange({ isExpanded: _isExpanded })
  }

  const classes = ['expandable-card', isExpanded && 'expandable-card--open']

  return (
    <div className={clsx(classes)}>
      <div className="expandable-card__header">
        <button
          type="button"
          className="expandable-card__button"
          onClick={handleButtonClick}
        >
          <div className="expandable-card__title">{title}</div>
          <div className="expandable-card__icon"></div>
        </button>
        {subtitle && (
          <div className="expandable-card__subtitle">{subtitle}</div>
        )}
      </div>
      <div
        className="expandable-card__body"
        ref={bodyRef}
        style={{ maxHeight: bodyMaxHeight }}
      >
        {children}
      </div>
    </div>
  )
}
